<template>
  <Command @click="trigger">
    <slot
      v-if="isSupported && isAllowed && !attributesStore.isIphone"
      v-bind="{ disabled: isToggling, icon, isFullscreen, label, toolTip }"
    />
  </Command>
</template>
<script setup lang="ts">
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useFullscreen } from "@vueuse/core";

import { useAttributesStore } from "@/stores/attributes";

import Command from "../command";

import { allowsFeature } from "../../../modules/browser/featurePolicy";

const { t } = useI18n();

const { isSupported, isFullscreen, toggle } = useFullscreen();
const isAllowed = allowsFeature("fullscreen");

const attributesStore = useAttributesStore();

const isToggling = ref<boolean>(false);

const icon = computed<string>(() =>
  isFullscreen.value ? "fullscreen_exit" : "fullscreen"
);

const label = computed<string>(() =>
  isFullscreen.value
    ? t("moreOptions.closeFullscreen")
    : t("moreOptions.fullscreen")
);

const toolTip = computed<string>(() => t("moreOptions.fullscreenIconTooltip"));

async function trigger() {
  if (isToggling.value) {
    return;
  }
  isToggling.value = true;
  try {
    await toggle();
  } finally {
    isToggling.value = false;
  }
}
</script>
